var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar',{scopedSlots:_vm._u([{key:"center",fn:function(){return [_vm._v(" Chat ")]},proxy:true}])}),_c('Chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }